import { render, staticRenderFns } from "./Orderlist.vue?vue&type=template&id=58c2945e&scoped=true"
import script from "./Orderlist.vue?vue&type=script&lang=js"
export * from "./Orderlist.vue?vue&type=script&lang=js"
import style0 from "./Orderlist.vue?vue&type=style&index=0&id=58c2945e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c2945e",
  null
  
)

export default component.exports